import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { Button } from "components/shared";
import StepInfo from "pages/StepPages/components";
import useDebounce from "../../../hooks/useDebounce";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { organizationsAPI } from "libs/apiClient/Organizations";
import { organizationAPI } from "libs/apiClient/Organization";
import {OrganizationSimpleResponse} from "../../../libs/apiClient/data-contracts";

interface HeaderProps {
	// setOrg: (id: number) => void;
	getDoc: () => void;
	forward: any;
	error: { read: boolean; edit: { active: boolean; snack(): void } };
}

const Header: FC<HeaderProps> = ({ getDoc, error, forward }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();
	const [organizations, setOrganizations] = useState<OrganizationSimpleResponse[]>([]);
	const [currentOrganization, setCurrentOrganization] = useState<OrganizationSimpleResponse | null>(null);

	const firstLoad = useRef(true);

	const [search, setSearch] = useState("");

	const query = useDebounce(search, 400);

	const setOrg = useCallback(
		(data: typeof organizations) => {
			const newData = error.read ? [{ id: 0, shortName: "Системные", fullName: "Системные",archived:false }, ...data] : data;
			setOrganizations(newData);
		},
		[error.read],
	);

	useEffect(() => {
		if (!firstLoad.current) {
			organizationsAPI
				.documentPatternsList({
					page: 1,
					num: 20,
					...(query && { query }),
				})
				.then(({ data }) => setOrg(data));
		} else {
			firstLoad.current = false;
		}
		//eslint-disable-next-line
	}, [query, error.read]);

	useEffect(() => {
		const urlParamsOrg = params.org !== undefined ? Number(params.org) : null;
		if (urlParamsOrg === null) {
			setCurrentOrganization(null);
		} else if (urlParamsOrg === 0) {
			setCurrentOrganization({ id: 0, shortName: "Системные", fullName: "Системные",archived:false });
		} else if (urlParamsOrg > 0) {
			organizationAPI.organizationDetail(urlParamsOrg!).then(({ data }) => setCurrentOrganization(data));
		}
		//eslint-disable-next-line
	}, []);

	return (
		<div className="step-header">
			<div>
				<StepInfo
					info="Справочник шаблонов документов"
					select={{
						onSelect: (organization: OrganizationSimpleResponse) => {
							navigate(`/references/document-templates/${organization.id}`, { replace: true, state: location.state });
							setCurrentOrganization(organization);
						},
						value: currentOrganization?.shortName || "",
						current: currentOrganization,
						options: organizations,
						field: ["shortName"],
						setQuery: (e: React.ChangeEvent<HTMLInputElement>) => {
							setSearch(e.target.value);
						},
						query: search,
						placeholder: "Организация не выбрана",
						ref: forward,
					}}
				/>
			</div>

			<div className="step-header__actions">
				{/* <Search
					className={cn("step-header__actions-item", styles.search)}
					value={searchValue}
					onChange={handleSearchValue}
				/> */}
				<Button onClick={getDoc} className="step-header__actions-item">
					Скачать инструкцию
				</Button>
			</div>
		</div>
	);
};

export default Header;
